import { render, staticRenderFns } from "./SliderInfo.vue?vue&type=template&id=d8045952&scoped=true"
import script from "./SliderInfo.vue?vue&type=script&lang=js"
export * from "./SliderInfo.vue?vue&type=script&lang=js"
import style0 from "./SliderInfo.vue?vue&type=style&index=0&id=d8045952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8045952",
  null
  
)

export default component.exports